import Vue from "vue";
import VueRouter from "vue-router";
import axios from "axios";
import { baseApiUrl } from "@/global";

import Home from "@/views/Home";
import Auth from "@/auth/Auth";
import Empresas from "@/views/Empresas";
import Eventos from "@/views/Eventos";
import Agenda from "@/views/Agenda";
import Inscricoes from "@/views/Inscricoes";
import Whatsapp from "@/views/Whatsapp";
import MapaEvento from "@/views/MapaEvento";
import Dispositivos from "@/views/Dispositivos";
import ModeloBase from "@/views/Pages/1ModeloBase";
import Imersao from "@/views/Pages/Imersao";
import Liberdade from "@/views/Pages/Liberdade";
/* import LibertyConference2022 from '@/views/Pages/LibertyConference2022' */
//import LibertyConference20 from '@/views/Pages/LibertyConference20-original'
//import LibertyConference20Online from '@/views/Pages/LibertyConference20Online'
import Tdmguarapari from "@/views/Pages/Tdmguarapari";
import Tdmvilavelha from "@/views/Pages/Tdmvilavelha";
import Imepg from "@/views/Pages/Imepg";
import PageSorteio from "@/views/Pages/PageSorteio";
import AnaMarques from "@/views/Pages/AnaMarques";
import Logos from "@/views/Pages/Logos";
import LibertyKids from "@/views/Pages/LibertyKids";
import OrdenacaoPastoral from "@/views/Pages/OrdenacaoPastoral";
import EscolaMinisterial from "@/views/Pages/EscolaMinisterial";
//import LibertyKidsDay from '@/views/Pages/LibertyKidsDay'
//import LibertyKidsDayLocal from '@/views/Pages/LibertyKidsDayLocal'
// import PerfumadasOnline from '@/views/Pages/PerfumadasOnline'
import Live from "@/views/Pages/Live";
import LibertyConference2021 from "@/views/Pages/LibertyConference2021";
import Valentes from "@/views/Pages/Valentes";
import FortalSeg from "@/views/Pages/FortalSeg";
import IgrejaDaLiberdade from "@/views/Pages/IgrejaDaLiberdade";
import ED2022 from "@/views/Pages/ED2022";
import ED2022Equipe from "@/views/Pages/ED2022Equipe";
import KLAJP from "@/views/Pages/KLAJP";
import KLAImpressao from "@/views/Pages/KLAImpressao";
import NovoVigilante from "@/views/Pages/NovoVigilante";
import About from "@/views/About";
import Login from "@/auth/Login";
import Vigilantes from "@/views/Vigilantes";
import FortalSegEvents from "@/views/Pages/FortalSegEvents";
import Convocacao from "@/views/Convocacao";
import AssociarQRCode from "@/views/AssociarQRCode";
import Checkin from "@/views/Checkin";
import Checkout from "@/views/Checkout";
import CriaQRCode from "@/views/CriaQRCode";
import AssociarQRCodeeCheckin from "@/views/AssociarQRCodeeCheckin";
// import SextaRosa from '@/views/Pages/SextaRosa'
import Preparadas from "@/views/Pages/Preparadas";
import Vital from "@/views/Pages/Vital";
import Divulgador from "@/views/Divulgador";
import ListaIndicacoes from "@/views/ListaIndicacoes";
// import Perfumadas from '@/views/Pages/Perfumadas2022'
import Vida from "@/views/Pages/Vida";
// import Sorteio from '@/views/Pages/Sorteio'
import Lojistas from "@/views/Pages/Lojistas";
import Transacoes from "@/views/Transacoes";
import Manancial from "@/views/Pages/Manancial";
import MulheresPerfumadas from '@/views/Pages/MulheresPerfumadas'
import MetodoPHD from "@/views/Pages/MetodoPHD";
// import LibertyKidsOld from "@/views/Pages/libertyKidsOld";
import NaMesa from "@/views/Pages/NaMesa";
import APrimeiraIgreja from "@/views/Pages/APrimeiraIgreja";
import Liv from "@/views/Pages/Liv";
import EscolaBiblica from "@/views/Pages/EscolaBiblica";
import Perfumadas2023 from "@/views/Pages/Perfumadas2023";
import TMTeamAlunos from "@/views/Pages/TMTeamAlunos";
import TMTeamGeral from "@/views/Pages/TMTeamGeral";
import RifaPerfumadas from "@/views/Pages/RifaPerfumadas";
import SGEventos from "@/views/Pages/SGEventos";
import SGEventos2 from "@/views/Pages/SGEventos2";
import FortalHair from "@/views/Pages/FortalHair";
import LinksSG from "@/views/Pages/LinksSG";
import BaboonRN from "@/views/Pages/BaboonRN";
import KLA from "@/views/Pages/KLA";
import LinksKLA from "@/views/Pages/LinksKLA";
import LinksBaboon from "@/views/Pages/LinksBaboon";
import Perfumadas2024 from "@/views/Pages/Perfumadas2024";
import EspacoAlegre from "@/views/Pages/EspacoAlegre";
import EspacoAlegre2 from "@/views/Pages/EspacoAlegre2";
import EspacoAlegre3 from "@/views/Pages/EspacoAlegre3";
import Sedentos from "@/views/Pages/Sedentos";
import Beleza from "@/views/Pages/Beleza";
import Cenaculo from "@/views/Pages/Cenaculo";
import ColegioIna from "@/views/Pages/ColegioIna";
import VistaAlegre from "@/views/Pages/VistaAlegre";
import EBF from "@/views/Pages/EBF";
import EBF_PIBJCU from "@/views/Pages/EBF_PIBJCU";
import EBF_PIBJCU2 from "@/views/Pages/EBF_PIBJCU2";
import Deboras from "@/views/Pages/Deboras";
import Restauradas from "@/views/Pages/Restauradas";
import EditarInscricao from "@/views/Pages/EditarInscricao";
import Oracao from "@/views/Pages/Oracao";
import Celiane from "@/views/Pages/Celiane";
import MapleBear from "@/views/Pages/MapleBear";
import MapleBear2 from "@/views/Pages/MapleBear2";
import Atos2 from "@/views/Pages/Atos2";
import ThomasNelson from "@/views/Pages/ThomasNelson";
import Impulse from "@/views/Pages/Impulse";
import DuoProducoes from "@/views/Pages/DuoProducoes";
import Perolas from "@/views/Pages/Perolas";

import { userKey } from "@/global";

Vue.use(VueRouter);

const routes = [
  {
    name: "home",
    path: "/home",
    component: Home,
    meta: { requiresAdmin: true },
  },
  {
    name: "auth",
    path: "/login",
    component: Auth,
    meta: { requiresAdmin: false },
  },
  {
    name: "sorteio",
    path: "/sorteio",
    component: PageSorteio,
    meta: { requiresAdmin: false },
  },
  {
    name: "empresas",
    path: "/empresas",
    component: Empresas,
    meta: { requiresAdmin: true },
  },
  {
    name: "eventos",
    path: "/eventos",
    component: Eventos,
    meta: { requiresAdmin: true },
  },
  {
    name: "mapa",
    path: "/mapa",
    component: MapaEvento,
    meta: { requiresAdmin: true },
  },
  {
    name: "agenda",
    path: "/agenda",
    component: Agenda,
    meta: { requiresAdmin: true },
  },
  { 
    name: "inscricoes", 
    path: "/inscricoes", 
    component: Inscricoes 
  },
  {
    name: "dispositivos",
    path: "/dispositivos",
    component: Dispositivos,
    meta: { requiresAdmin: true },
  },
  {
    name: "modelo",
    path: "/modelo",
    component: ModeloBase,
    meta: { requiresAdmin: false },
  },
  {
    name: "liberdade",
    path: "/liberdade",
    component: Liberdade,
    meta: { requiresAdmin: false },
  },
  {
    name: "oracao",
    path: "/oracao",
    component: Oracao,
    meta: { requiresAdmin: false },
  },
  {
    name: "anamarques",
    path: "/anamarques",
    component: AnaMarques,
    meta: { requiresAdmin: false },
  },
  //{ name: 'libertyConference20', path: '/libertyconference20', component: LibertyConference20, meta: { requiresAdmin: false } },
  //{ name: 'libertyConference20Live', path: '/libertyconference20Live', component: LibertyConference20Online, meta: { requiresAdmin: false } },
  {
    name: "tdmguarapari",
    path: "/tdmguarapari",
    component: Tdmguarapari,
    meta: { requiresAdmin: false },
  },
  {
    name: "tdmvilavelha",
    path: "/tdmvilavelha",
    component: Tdmvilavelha,
    meta: { requiresAdmin: false },
  },
  {
    name: "imepg",
    path: "/imepg",
    component: Imepg,
    meta: { requiresAdmin: false },
  },
  {
    name: "ordenacaopastoral",
    path: "/ordenacaopastoral",
    component: OrdenacaoPastoral,
    meta: { requiresAdmin: false },
  },
  {
    name: "segurancaevents",
    path: "/seguranca/eventos",
    component: FortalSegEvents,
    meta: { requiresAdmin: false },
  },
  // { name: 'seminario', path: '/seminario', component: Seminario, meta: { requiresAdmin: false } },
  {
    name: "imersao",
    path: "/imersao",
    component: Imersao,
    meta: { requiresAdmin: false },
  },
  // { name: 'perfumadas', path: '/perfumadas', component: Perfumadas, meta: { requiresAdmin: false }},
  {
    name: "kids",
    path: "/kids",
    component: LibertyKids,
    meta: { requiresAdmin: false },
  },
  {
    name: "viver",
    path: "/viver",
    component: Logos,
    meta: { requiresAdmin: false },
  },
  {
    name: "escolaministerial",
    path: "/escolaministerial",
    component: EscolaMinisterial,
    meta: { requiresAdmin: false },
  },
  //{ name: 'libertykidsday', path: '/libertykidsday', component: LibertyKidsDay, meta: { requiresAdmin: false } },
  //{ name: 'libertykidsdaylocal', path: '/libertykidsdaylocal', component: LibertyKidsDayLocal, meta: { requiresAdmin: false } },
  // { name: 'perfumadasonline', path: '/perfumadasonline', component: PerfumadasOnline, meta: { requiresAdmin: false } },
  {
    name: "live",
    path: "/live",
    component: Live,
    meta: { requiresAdmin: false },
  },
  {
    name: "libertyconference21",
    path: "/libertyconference21",
    component: LibertyConference2021,
    meta: { requiresAdmin: false },
  },
  {
    name: "valentes",
    path: "/valentes",
    component: Valentes,
    meta: { requiresAdmin: false },
  },
  {
    name: "igrejadaliberdade",
    path: "/igrejadaliberdade",
    component: IgrejaDaLiberdade,
    meta: { requiresAdmin: false },
  },
  {
    name: "novovigilante",
    path: "/novovigilante",
    component: NovoVigilante,
    meta: { requiresAdmin: false },
  },
  {
    name: "seguranca",
    path: "/seguranca",
    component: FortalSeg,
    meta: { requiresAdmin: false },
  },
  {
    name: "about",
    path: "/",
    component: About,
    meta: { requiresAdmin: false },
  },
  {
    name: "painel",
    path: "/painel",
    component: Login,
    meta: { requiresAdmin: false },
  },
  {
    name: "vigilantes",
    path: "/vigilantes",
    component: Vigilantes,
    meta: { requiresAdmin: true },
  },
  {
    name: "convocacao",
    path: "/convocacao",
    component: Convocacao,
    meta: { requiresAdmin: true },
  },
  {
    name: "associarqrcode",
    path: "/associarqrcode",
    component: AssociarQRCode,
    meta: { requiresAdmin: true },
  },
  {
    name: "checkin",
    path: "/checkin",
    component: Checkin,
    meta: { requiresAdmin: true },
  },
  {
    name: "checkout",
    path: "/checkout",
    component: Checkout,
    meta: { requiresAdmin: true },
  },
  {
    name: "criaqrcode",
    path: "/criaqrcode",
    component: CriaQRCode,
    meta: { requiresAdmin: true },
  },
  {
    name: "associarqrcodecheckin",
    path: "/associarqrcodecheckin",
    component: AssociarQRCodeeCheckin,
    meta: { requiresAdmin: true },
  },
  {
    name: "ed2022",
    path: "/ed2022",
    component: ED2022,
    meta: { requiresAdmin: false },
  },
  {
    name: "ed2022equipe",
    path: "/ed2022equipe",
    component: ED2022Equipe,
    meta: { requiresAdmin: false },
  },
  {
    name: "grupoklajp",
    path: "/grupoklajp",
    component: KLAJP,
    meta: { requiresAdmin: false },
  },
  {
    name: "klaimpressao",
    path: "/klaimpressao",
    component: KLAImpressao,
    meta: { requiresAdmin: false },
  },
  // { name: 'sextarosa', path: '/sextarosa', component: SextaRosa, meta: { requiresAdmin: false } },
  {
    name: "preparadas",
    path: "/preparadas",
    component: Preparadas,
    meta: { requiresAdmin: false },
  },
  {
    name: "vital",
    path: "/vital",
    component: Vital,
    meta: { requiresAdmin: false },
  },
  {
    name: "divulgador",
    path: "/divulgador",
    component: Divulgador,
    meta: { requiresAdmin: true },
  },
  {
    name: "listaindicacoes",
    path: "/listaindicacoes",
    component: ListaIndicacoes,
    meta: { requiresAdmin: true },
  },
  // { name: 'perfumadas', path: '/perfumadas', component: Perfumadas, meta: { requiresAdmin: false } },
  {
    name: "vida",
    path: "/vida",
    component: Vida,
    meta: { requiresAdmin: false },
  },
  {
    name: "lojistas",
    path: "/lojistas",
    component: Lojistas,
    meta: { requiresAdmin: false },
  },
  {
    name: "transacoes",
    path: "/transacoes",
    component: Transacoes,
    meta: { requiresAdmin: true },
  },
  {
    name: "manancial",
    path: "/manancial",
    component: Manancial,
    meta: { requiresAdmin: false },
  },
  { name: 'mulheresperfumadas', path: '/mulheresperfumadas', component: MulheresPerfumadas, meta: { requiresAdmin: false } },
  {
    name: "metodophd",
    path: "/metodophd",
    component: MetodoPHD,
    meta: { requiresAdmin: false },
  },
  {
    name: "libertykids",
    path: "/libertykids",
    component: LibertyKids,
    meta: { requiresAdmin: false },
  },
  {
    name: "namesa",
    path: "/namesa",
    component: NaMesa,
    meta: { requiresAdmin: false },
  },
  {
    name: "aprimeiraigreja",
    path: "/aprimeiraigreja",
    component: APrimeiraIgreja,
    meta: { requiresAdmin: false },
  },
  { name: "liv", path: "/liv", component: Liv, meta: { requiresAdmin: false } },
  {
    name: "escolabiblica",
    path: "/escolabiblica",
    component: EscolaBiblica,
    meta: { requiresAdmin: false },
  },
  {
    name: "perfumadas2023",
    path: "/perfumadas2023",
    component: Perfumadas2023,
    meta: { requiresAdmin: false },
  },
  {
    name: "alunoscheckmat",
    path: "/alunoscheckmat",
    component: TMTeamAlunos,
    meta: { requiresAdmin: false },
  },
  {
    name: "outrasequipes",
    path: "/outrasequipes",
    component: TMTeamGeral,
    meta: { requiresAdmin: false },
  },
  {
    name: "rifaperfumadas",
    path: "/rifaperfumadas",
    component: RifaPerfumadas,
    meta: { requiresAdmin: false },
  },
  {
    name: "barberpronordeste",
    path: "/barberpronordeste",
    component: SGEventos,
    meta: { requiresAdmin: false },
  },
  {
    name: "up",
    path: "/up",
    component: SGEventos2,
    meta: { requiresAdmin: false },
    beforeEnter: (to, from, next) => {
      const urlParams = new URLSearchParams(window.location.search);
      const codInscricao = urlParams.get('cod');
      
      if (!codInscricao) {
        next('/barberpronordeste'); // Redireciona para a página principal se não houver código
      } else {
        next(); // Permite acessar a página se houver código
      }
    }
  },
  {
    name: "fortalbarber",
    path: "/fortalbarber",
    component: FortalHair,
    meta: { requiresAdmin: false },
  },
  {
    name: "sg",
    path: "/barberpro",
    component: LinksSG,
    meta: { requiresAdmin: false },
  },
  {
    name: "baboonrn",
    path: "/baboonrn",
    component: BaboonRN,
    meta: { requiresAdmin: false },
  },
  {
    name: "klaeventos",
    path: "/klaeventos",
    component: KLA,
    meta: { requiresAdmin: false },
  },
  {
    name: "kla",
    path: "/kla",
    component: LinksKLA,
    meta: { requiresAdmin: false },
  },
  {
    name: "baboon",
    path: "/baboon",
    component: LinksBaboon,
    meta: { requiresAdmin: false },
  },
  {
    name: "perfumadas",
    path: "/perfumadas",
    component: Perfumadas2024,
    meta: { requiresAdmin: false },
  },
  {
    name: "espacoalegre",
    path: "/espacoalegre",
    component: EspacoAlegre,
    meta: { requiresAdmin: false },
  },
  {
    name: "enatal",
    path: "/enatal",
    component: EspacoAlegre2,
    meta: { requiresAdmin: false },
  },
  {
    name: "senhaextra",
    path: "/senhaextra",
    component: EspacoAlegre3,
    meta: { requiresAdmin: false },
  },
  {
    name: "sedentos",
    path: "/sedentos",
    component: Sedentos,
    meta: { requiresAdmin: false },
  },
  {
    name: "beleza",
    path: "/beleza",
    component: Beleza,
    meta: { requiresAdmin: false },
  },
  {
    name: "cenaculo",
    path: "/cenaculo",
    component: Cenaculo,
    meta: { requiresAdmin: false },
  },
  {
    name: "colegioina",
    path: "/colegioina",
    component: ColegioIna,
    meta: { requiresAdmin: false },
  },
  {
    name: "vistaalegre",
    path: "/vistaalegre",
    component: VistaAlegre,
    meta: { requiresAdmin: false },
  },
  {
    name: "ebf",
    path: "/ebf",
    component: EBF,
    meta: { requiresAdmin: false },
  },
  {
    name: "/pibjcu",
    path: "/pibjcu",
    component: EBF_PIBJCU,
    meta: { requiresAdmin: false },
  },
  {
    name: "/banquete",
    path: "/banquete",
    component: EBF_PIBJCU2,
    meta: { requiresAdmin: false },
  },
  {
    name: "deboras",
    path: "/deboras",
    component: Deboras,
    meta: { requiresAdmin: false },
  },
  {
    name: "restauradas",
    path: "/restauradas",
    component: Restauradas,
    meta: { requiresAdmin: false },
  },
  {
    name: "editinsc",
    path: "/editinsc",
    component: EditarInscricao,
    meta: { requiresAdmin: false },
  },
  {
    name: "whatsapp",
    path: "/whatsapp",
    component: Whatsapp,
    meta: { requiresAdmin: true },
  },
  {
    name: "celiane",
    path: "/celiane",
    component: Celiane,
    meta: { requiresAdmin: false },
  },
  {
    name: "maplebear",
    path: "/maplebear",
    component: MapleBear,
    meta: { requiresAdmin: false },
  },
  {
    name: "maplebeareventos",
    path: "/maplebeareventos",
    component: MapleBear2,
    meta: { requiresAdmin: false },
  },
  {
    name: "collab",
    path: "/collab",
    component: Atos2,
    meta: { requiresAdmin: false },
  },
  {
    name: "conferencia-thomas-nelson-2025",
    path: "/conferencia-thomas-nelson-2025",
    component: ThomasNelson,
    meta: { requiresAdmin: false },
  },
  {
    name: "impulse",
    path: "/impulse",
    component: Impulse,
    meta: { requiresAdmin: false },
  },
  {
    name: "duoproducoes",
    path: "/duoproducoes",
    component: DuoProducoes,
    meta: { requiresAdmin: false },
  },
  {
    name: "perolas",
    path: "/perolas",
    component: Perolas,
    meta: { requiresAdmin: false },
  },
];

/* const router = new VueRouter({
  routes
}) */
const router = new VueRouter({
  mode: "history",
  routes,
});

//Controla segurança de rotas
router.beforeEach((to, from, next) => {
  const json = sessionStorage.getItem(userKey);

  if (to.matched.some((record) => record.meta.requiresAdmin)) {
    const user = JSON.parse(json);
    if (
      user === "GERENTE" ||
      user === "ADMIN" ||
      user === "CHECKIN" ||
      user === "CHECKOUT" ||
      user === "NOTIFY"
    )
      next();
    else next({ path: "/" });
  } else {
    next();
  }
});

router.afterEach(() => {
  async function verificaVersao() {
    try {
      const response = await axios.get(baseApiUrl + "Configuracoes/versao");
      if (response.data.versao) {
        if (!localStorage.getItem("versao")) {
          localStorage.setItem("versao", response.data.versao);
        } else if (localStorage.getItem("versao") != response.data.versao) {
          localStorage.setItem("versao", response.data.versao);
          window.location.reload(true);
        }
      }
    } catch (error) {
      //
    }
  }

  verificaVersao();
});

export default router;
